/* @flow */
//import { asyncComputed } from 'computed-async-mobx';
import { autorun, observable } from 'mobx';

import Api from 'api/Api';

let c: number = 0;

export class Manufacturer {
  @observable id: number = c++;

  @observable name: ?string = 'TEST';

  @observable key: ?string = 'TEST' + c++;

  @observable code: ?string = 'TEST';

  @observable shortCode: string = 'TEST';

  @observable keyOEM: ?boolean;

  @observable statusId: number = 0;

  constructor(n: ?string) {
    this.name = n;
  }
}

export class Asset {
  @observable locationId: number = 0;

  @observable productModelId: ?number = null;

  @observable saleConsignment: ?boolean;

  @observable subRentalProgram: ?boolean;

  @observable safetyTested: ?boolean;

  @observable additionalInformation: string = '';

  @observable statusId: ?number = null;

  @observable assignedUserId: ?number = null;

  @observable relationshipId: ?number = null;

  @observable parentAssetId: ?number = null;

  @observable conditionId: ?number = null;

  @observable softwareVersion: string = '';

  @observable firmwareVersion: string = '';

  @observable serialNumber: string = '';
}

/* export class Option {
    @observable id: number = 0;

    @observable modelId: number = 0;
    //or productId?
    @observable name: string = '';
}
 */

export class Project {
  @observable id: number = 0;

  @observable code: string = '';

  @observable name: string = '';

  @observable description: string = '';

  @observable startDate: ?Date = null;

  @observable endDate: ?Date = null;

  @observable costCentreId: ?number = null;

  @observable locationId: ?number = null;

  @observable statusId: ?number = null;

  @observable projectAssigneeUserId: ?number = null;

  @observable projectEngineerUserId: ?number = null;
}

/* class CostCentre {
    @observable id: number = 0;

    @observable name: string = '';

    @observable description: string = '';

    @observable disabled: ?boolean;

}
*/

export class Product {
  @observable id: number = c++;

  @observable manufacturerId: ?number = null;

  @observable name: ?string = 'TESTPRODUCT';

  @observable productGroupCode: string = 'PGC';

  @observable productGroupDescription: string = 'PGD';

  @observable productGroupKey: string = 'PGK';

  @observable description: string = 'DESC' + c++;

  @observable baseModel: string = 'BM';

  @observable marketValue: number = 0;

  @observable statusId: number = 0;

  constructor(productName: ?string) {
    this.name = productName;
  }
}

export class ManufacturersProductsModel {
  @observable selectedManufacturer: *;

  @observable selectedProduct: *;

  @observable manufacturers: Array<*> = [];

  @observable products: Array<*> = [];

  constructor(api: Api) {
    autorun(
      async (): Promise<void> => {
        if (api.isAuthorised()) {
          this.manufacturers = await api.getResource('manufacturer');
        }
      }
    );
    autorun(
      async (): Promise<void> => {
        if (api.isAuthorised() && this.selectedManufacturer) {
          this.products = await api.getResource('products/' + this.selectedManufacturer.id);
        }
      }
    );
  }
}
